import React from "react";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Paper, Box, Grid, Hidden, Card } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import LobConstants from "../../constants/LobConstants";
import useStyles from "../../themes/makeStyles";
export default function MainHeading(props) {
  /*
  signature:input title and path to navigate returns heading bar
  Description: this is used to display heading bar in every page with breadcrumb
  Purpose: to display heading and also display breadcrumb for path
  
  */
  const classes = useStyles();
  return (
    <Box py={3}>
      <SimpleBreadcrumbs
        path={props.path}
        className={classes.subText}
      />
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item  >
          {/* <h2 className={classes.mainHeading}> {props.title}</h2> */}

        </Grid>
        <Grid item className={classes.flexGrow}>
          <Box color="success.main">
            <h3 className={classes.statusHeading} align="right">{props.isEdit ? "Update" : "New"}</h3>
          </Box>
          <Typography
            variant="h6"
            className={classes.statusSubHeading}
            align="right"
          >
            {props.title}
          </Typography>
        </Grid>
      </Grid>
    </Box>

  );
}

function handleClick(event) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

function SimpleBreadcrumbs(props) {
  const subPath = props.path.split("/");
  //console.log(subPath);
  let path = "";
  const classes = useStyles();
  return (
    <Breadcrumbs aria-label="breadcrumb">
      {subPath.map((sub, index) => {
        path = path + sub;
        if (index + 1 != subPath.length) {
          if (sub != LobConstants.LOB) {
            return <Link key={index} href={sub} className={classes.mainBreadcrumbs}>{sub}</Link>;
          }
        } else {
          return <Typography key={index} color="textPrimary" className={classes.childBreadcrumbs}>{sub}</Typography>;
        }
      })}
    </Breadcrumbs>
  );
}
